import { Fragment, useState } from 'react';
import { CardBody, Button, Col, Row, Card } from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import { Check, Download, X } from 'react-feather';
import axios from 'axios';
import { useSelector } from 'react-redux';

const FileUploaderSingle = ({ setField }) => {
  // ** State
  const [files, setFiles] = useState([]);
  // const [uploaded] = useState(false);
  const {
    auth: { userData }
  } = useSelector((state) => state);
  const [uploaded, setUploaded] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    onDrop: (acceptedFiles) => {      
      setFiles([...acceptedFiles.map((file) => Object.assign(file))]);
    },
    maxFiles: 1
  });

  const handleUploadAWS = async (file) => {
    //
    const formData = new FormData();
    formData.append('file', file); // Añadir el archivo a FormData

    try {
      const response = await axios.post('https://api.soysublimeapp.com/activity/file-upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization : `Bearer ${userData?.accessToken}` // Añadir el token en la cabecera
        },
      });

      console.log('Respuesta del servidor:', response.data);
      setField(response.data.name);
      setUploaded(true);
      alert('Archivo subido con éxito');
    } catch (error) {
      console.error('Error al subir el archivo:', error);
      alert('Error al subir el archivo');
    }
  };

  const handleRemoveFile = (file) => {
    const uploadedFiles = files;
    const filtered = uploadedFiles.filter((i) => i.name !== file.name);
    setFiles([...filtered]);
  };

  const fileList = files.map((file, index) => (
    <div
      key={`${file.name}-${index}`}
      className="d-flex align-items-center justify-content-between"
    >
      <div className="file-details d-flex align-items-center">
        <div>
          <p
            className="file-name mb-0 "
            style={{ color: '#636A6C', fontWeight: '600' }}
          >
            {file.name.length > 30 ? `${file.name.slice(0, 25)}...` : file.name}
          </p>
        </div>
      </div>
      <div>
        {!uploaded ? (
          <Fragment>
            <Button
              color="primary1"
              size="sm"
              className="btn-icon mx-2"
              onClick={() => handleUploadAWS(file)}
            >
              <Check size={18} color="#0F0A2B" />
            </Button>

            <Button
              color="primary3"
              size="sm"
              className="btn-icon"
              onClick={() => handleRemoveFile(file)}
            >
              <X size={18} color="#0F0A2B" />
            </Button>
          </Fragment>
        ) : null}
      </div>
    </div>
  ));

  return (
    <Fragment>
      {!uploaded && (
        <Card
          className="color-card-upload"
          style={{
            borderRadius: '45px',
            width: '100%',
            height: '235px',
            padding: 0
          }}
        >
          <CardBody>
            <Row>
              <Col md="12">
                <div {...getRootProps({ className: 'dropzone' })}>
                  <Row>
                    <Col md="10"></Col>
                    <Col md="">
                      <svg width="21" height="21" viewBox="0 0 21 21">
                        <g transform="translate(-1611 -218)">
                          <circle
                            cx="10.5"
                            cy="10.5"
                            r="10.5"
                            transform="translate(1611 218)"
                          />
                          <g transform="translate(1616.82 223.83)">
                            <path
                              d="M2.844,12.037l-.558,2.407a.6.6,0,0,0,.587.734.628.628,0,0,0,.126,0l2.421-.558L10.07,9.989,7.475,7.4Z"
                              transform="translate(-2.272 -5.762)"
                              fill="#fff"
                            />
                            <path
                              d="M25.271,3.726,23.54,1.994a.608.608,0,0,0-.857,0l-.963.963,2.592,2.592.963-.963a.608.608,0,0,0,0-.86Z"
                              transform="translate(-16.012 -1.817)"
                              fill="#fff"
                            />
                          </g>
                        </g>
                      </svg>
                    </Col>
                  </Row>
                  <input {...getInputProps()} />
                  <div className="d-flex align-items-center justify-content-center flex-column mt-3">
                    <svg width="64" height="80" viewBox="0 0 64 80">
                      <path
                        d="M14,3H54L70,19V75a8,8,0,0,1-8,8H14a8,8,0,0,1-8-8V11a8,8,0,0,1,8-8Zm36,8H14V75H62V23H50ZM18,43H30l8,8,8-8H58L46,55,58,67H46l-8-8-8,8H18L30,55Z"
                        transform="translate(-6 -3)"
                        fill="#757488"
                        fillRule="evenodd"
                        opacity="0.297"
                      />
                    </svg>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
      {files.length ? <div className="my-2 px-2">{fileList}</div> : null}
    </Fragment>
  );
};

export default FileUploaderSingle;
